import DepositBoxValue from './DepositBoxValue';

export default class CustomDepositBoxValue extends DepositBoxValue {
    public value: number;

    public static create(value: number): CustomDepositBoxValue {
        return new CustomDepositBoxValue({ id: 0, value, is_custom_value: true });
    }
}
